import moment from 'moment'

const CURRENT = 'current_year'
const PAST = 'past_year'
const NEXT = 'next_year'
const OTHER = 'other'

export const getPeriodRange = (startDate: string, endDate: string) => {
  const startOfCurrentYear = moment().startOf('year')
  const endOfCurrentYear = moment().endOf('year')

  const startOfYear = moment(startDate).startOf('day')
  const endOfYear = moment(endDate).endOf('day')

  if (startOfYear.isSame(startOfCurrentYear) && endOfYear.isSame(endOfCurrentYear)) {
    return CURRENT
  }

  if (
    startOfYear.isSame(startOfCurrentYear.clone().subtract(1, 'year')) &&
    endOfYear.isSame(endOfCurrentYear.clone().subtract(1, 'year'))
  ) {
    return PAST
  }

  if (
    startOfYear.isSame(startOfCurrentYear.clone().add(1, 'year')) &&
    endOfYear.isSame(endOfCurrentYear.clone().add(1, 'year'))
  ) {
    return NEXT
  }

  return OTHER
}
